import Equipe from "./equipe";

export default class Pool {
    joueurs= [];
    options=  null;
    parties=[];
    historiqueJoueurs=[];
    indexPool=0;
    constructor (options, indexPool) {
        this.options = options;
        
        this.indexPool = indexPool;
    }
    initHisto() {
        this.parties.forEach(partie=>{
            partie.equipes.forEach(equipe=>{
                equipe.initHisto(this.historiqueJoueurs);
            })
        })
    }
    getJson() {
        var partiesJSON = {
            parties: [],
            joueurs: this.joueurs,
            qualifies: this.qualifies
        };
        this.parties.forEach((partie)=>{
            var partieJSON = {
                equipes: []
            }
            partie.equipes.forEach(equipe=>{
                partieJSON.equipes.push(equipe.getJson())
            })
            
            partiesJSON.parties.push(partieJSON);
        })
        
        return partiesJSON;
    }
    random(min, max) {
        return Math.floor(min + Math.random() * (max - min));
    }
    
    init_BARRAGE() {
        var nbGagneJoueurs={};
        this.parties.splice(2, this.parties.length);
        this.parties.forEach((partie, indexPartie)=>{
            if (indexPartie < 2) {
                partie.equipes.forEach((equipe)=>{
                    if (equipe.score["joueurs"]!=null) {
                        if (typeof(nbGagneJoueurs[equipe.dataJoueurs.contre.J1])=="undefined")
                            nbGagneJoueurs[equipe.dataJoueurs.contre.J1] = 0;
                        if (typeof(nbGagneJoueurs[equipe.dataJoueurs.joueurs.J1])=="undefined")
                            nbGagneJoueurs[equipe.dataJoueurs.joueurs.J1] = 0;
                        if (equipe.score["joueurs"]>equipe.score["contre"]) {
                            nbGagneJoueurs[equipe.dataJoueurs.joueurs.J1] ++;
                        }
                        else  {
                            nbGagneJoueurs[equipe.dataJoueurs.contre.J1]  ++;
                        }
                    }
                   /* else if (indexPartie==1) {
                        if (typeof(nbGagneJoueurs[equipe.dataJoueurs.joueurs.J1])!="undefined")
                            delete nbGagneJoueurs[equipe.dataJoueurs.joueurs.J1];
                        if (typeof(nbGagneJoueurs[equipe.dataJoueurs.contre.J1])!="undefined")
                            delete nbGagneJoueurs[equipe.dataJoueurs.contre.J1];
                    }*/
                    
                })
            } 
        })
        var boolOK = false;
       
        var newPartie = {
            equipes: []
        }
        newPartie.equipes[0] = new Equipe(this.options, this.indexPool);
        newPartie.equipes[1] = new Equipe(this.options, this.indexPool);
        newPartie.equipes[1].state="FINISH";
        
        for (var key in nbGagneJoueurs) {
            if (nbGagneJoueurs[key] == 1) {
                if (!boolOK) {
                    newPartie.equipes[0].dataJoueurs.joueurs.J1 = key;
                    boolOK = true;
                }
                else {
                    newPartie.equipes[0].dataJoueurs.contre.J1 = key;
                    boolOK = false;
                }
                    
            }
            if (nbGagneJoueurs[key] == 2) {
                    newPartie.equipes[1].dataJoueurs.joueurs.J1 = key;
            }
            if (nbGagneJoueurs[key] == 0) {
                    newPartie.equipes[1].dataJoueurs.contre.J1 = key;
            }
        }
        
        this.parties.push(newPartie);
    }
    init_TOUR2() {
     
        var partie = this.parties[0];
        this.parties.splice(1, this.parties.length);
        var historiqueResultatJoueurs={};
        var numeroPP=[];
        var numeroGG=[];
        var addPartie = true;
        var nbEquipes = partie.equipes.length;
     
        partie.equipes.forEach((equipe, indexEquipe)=>{
        
            if (equipe.score["joueurs"]==null)
                addPartie = false;
            else {
               
                if (equipe.score["joueurs"]>equipe.score["contre"]) {
                   numeroGG[indexEquipe] = equipe.dataJoueurs.joueurs.J1
                   numeroPP[indexEquipe] = equipe.dataJoueurs.contre.J1
                }
                else  {
                    numeroPP[indexEquipe] = equipe.dataJoueurs.joueurs.J1
                    numeroGG[indexEquipe] = equipe.dataJoueurs.contre.J1
                }
            }
        })
      /*
        if (addPartie) {
            var newPartie = {
                equipes: []
            }
            var result = 0;
            var listJoueurs = this.joueurs.splice();
            for (var indexEquipe=0;indexEquipe<nbEquipes;indexEquipe++) {
                newPartie.equipes[indexEquipe] = new Equipe(this.options);
                // En tour 2 soit on a gagné 1 partie soit on l'a perdu
                // on met dans listNumeros les gagnants puis on mettra les perdants
                var listNumeros = [];
               
                for (var numeroJoueur in historiqueResultatJoueurs) {
                    if (historiqueResultatJoueurs[numeroJoueur] == result) {
                        listNumeros.push(numeroJoueur);
                    }
                }
                if (listNumeros.length<=1) {
                    for (var numeroJoueur in historiqueResultatJoueurs) {
                        listNumeros.push(numeroJoueur);
                    }
                }
                
                
               
                for (var numeroJoueur in historiqueResultatJoueurs) {
                    if (listNumeros.indexOf(numeroJoueur) == -1 && historiqueResultatJoueurs[numeroJoueur] == result)
                        delete historiqueResultatJoueurs[numeroJoueur];
                }
                if (listNumeros.length<=1) 
                    result++;
            }
            this.parties.push(newPartie);
        }
        */
     
        if (addPartie) {
            var newPartie = {
                equipes: []
            }
            
            newPartie.equipes[0] = new Equipe(this.options, this.indexPool);
            newPartie.equipes[0].dataJoueurs.joueurs.J1 = numeroGG[0];
            newPartie.equipes[0].dataJoueurs.contre.J1 = numeroGG[1];
            if (numeroGG[1] == null) {
                newPartie.equipes[0].score.joueurs = 13;
                newPartie.equipes[0].score.contre = 7;
                newPartie.equipes[0].state="FINISH";
            }
            
            newPartie.equipes[1] = new Equipe(this.options, this.indexPool);
            newPartie.equipes[1].dataJoueurs.joueurs.J1 = numeroPP[0];
            newPartie.equipes[1].dataJoueurs.contre.J1 = numeroPP[1];
            if (numeroPP[1] == null) {
                newPartie.equipes[1].score.joueurs = 13;
                newPartie.equipes[1].score.contre = 7;
                newPartie.equipes[1].state="FINISH";
            }
           
            this.parties.push(newPartie);
        }
        
    }
    init() {
        for (var indexPartie=0;indexPartie<this.options.nbTourPool;indexPartie++) {
            var partie = {
                equipes: [],
                id: indexPartie
            }
            var listNumeros = this.joueurs.slice(); // copy du tableau
            var indexEquipe = 0;
           
            while (listNumeros.length>0) {
                partie.equipes[indexEquipe] = new Equipe(this.options, this.indexPool);
                partie.equipes[indexEquipe].init(listNumeros, this.historiqueJoueurs);
                indexEquipe++;
            }
            this.parties[indexPartie] = partie;
            
        }
        
    }
    initJoueurs (listNumeros) {
        for (var indexJoueur=0;indexJoueur<this.options.nbJoueursParPool;indexJoueur++) {
            var indexTempo = this.random(0, listNumeros.length);
          
            var numeroJoueur = listNumeros[indexTempo];
           
            if (typeof(numeroJoueur)!="undefined") {
                listNumeros.splice(indexTempo, 1);
                this.joueurs.push(numeroJoueur);
            }
        }
    }
}